// SidebarContext.tsx
import { createContext } from "react";

export enum SidebarState {
  NAV,
  SEARCH,
  CLOSED,
}

type SidebarContextType = {
  sidebarState: SidebarState;
  setSidebarState: (state: SidebarState) => void;
  toggleSidebarState: (state: SidebarState) => void;
};

export const SidebarContext = createContext<SidebarContextType>({
  sidebarState: SidebarState.CLOSED,
  setSidebarState: () => {},
  toggleSidebarState: () => {},
});
